import { useParams } from 'react-router-dom';
import InterventionEpaysage from '@repo/ui/features/inventaires/epaysage/intervention';

export default function EpaysageInterventionPage() {
  const { id = '' } = useParams<{ id?: string }>();

  return (
    <div className="w-full py-6">
      <InterventionEpaysage inventaireId={Number(id)} />
    </div>
  );
}
